/**
 * FAQ Schema Generator
 * Adds structured data for FAQ accordions when FAQ style is selected
 */
document.addEventListener('DOMContentLoaded', function() {
    // Find all accordions with FAQ style
    const faqAccordions = document.querySelectorAll('.wp-block-thinkific-accordion.is-style-faq-accordion');
    
    if (faqAccordions.length > 0) {
        faqAccordions.forEach(accordion => {
            // Get all questions and answers from the accordion
            const questions = accordion.querySelectorAll('.thinkific-accordion-item');
            const faqData = {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": []
            };

            // Build the FAQ data structure
            questions.forEach(item => {
                const question = item.querySelector('.thinkific-question');
                const answer = item.querySelector('.thinkific-accordion-item-content');
                
                if (question && answer) {
                    faqData.mainEntity.push({
                        "@type": "Question",
                        "name": question.textContent.trim(),
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": answer.innerHTML.trim()
                        }
                    });
                }
            });

            // Only add schema if we have questions
            if (faqData.mainEntity.length > 0) {
                // Create and append the schema script
                const script = document.createElement('script');
                script.type = 'application/ld+json';
                script.textContent = JSON.stringify(faqData);
                document.head.appendChild(script);

            }
        });
    }
}); 